import { Audience } from '@/models/audiences';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type AudienceEditState = {
  audience?: Partial<Audience>;
};

export const initialState: AudienceEditState = {
  audience: undefined,
};

const audienceEditSlice = createSlice({
  name: 'audienceEdit',
  initialState,
  reducers: {
    stashAudience: (state, action: PayloadAction<Partial<Audience>>) => ({
      ...state,
      audience: { ...state.audience, ...action.payload },
    }),
    clearStashedAudience: (state) => ({
      ...state,
      audience: undefined,
    }),
  },
});

export const { stashAudience, clearStashedAudience } = audienceEditSlice.actions;

export default audienceEditSlice.reducer;
